import { Pipe, PipeTransform } from '@angular/core';
import { Subject, timer } from 'rxjs';
import { formatDuration } from '../utils/duration.util';

@Pipe({
  name: 'countDown',
})
export class CountDownPipe implements PipeTransform {
  remainingTime = new Subject();
  transform(value: number) {
    const date = new Date(value);
    const holdDatePlusOneDay = new Date(date.setDate(date.getDate() + 1)).getTime();
    timer(0, 1000).subscribe(() => {
      const diffTime = holdDatePlusOneDay - new Date().getTime();
      if (diffTime < 0) {
        this.remainingTime.next(formatDuration(0));
      } else {
        this.remainingTime.next(formatDuration(diffTime));
      }
    });

    return this.remainingTime;
  }
}
